import { render, staticRenderFns } from "./SocialEssaysPage.vue?vue&type=template&id=e70f6bbe&scoped=true"
import script from "./SocialEssaysPage.vue?vue&type=script&lang=js"
export * from "./SocialEssaysPage.vue?vue&type=script&lang=js"
import style0 from "./SocialEssaysPage.vue?vue&type=style&index=0&id=e70f6bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f6bbe",
  null
  
)

export default component.exports